import { render, staticRenderFns } from "./CompareProductsPage.vue?vue&type=template&id=6f893461&scoped=true&"
import script from "./CompareProductsPage.vue?vue&type=script&lang=js&"
export * from "./CompareProductsPage.vue?vue&type=script&lang=js&"
import style0 from "./CompareProductsPage.vue?vue&type=style&index=0&id=6f893461&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f893461",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/wouter/apps/go02/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VApp,VBtn,VCard,VContainer,VFlex,VIcon,VLayout})
